import Accordion from '@components/Accordion';
import Checkbox from '@components/Checkbox';
import Column from '@components/Column';
import Row from '@components/Row';
import Text from '@components/Text';
import colors from '@constants/colors';
import { css } from '@emotion/react';
import styled from '@emotion/styled';
import useTermCategories from '@hooks/term/useTermCategories';
import { Link } from '@stackflow/link';
import { useTranslation } from 'react-i18next';

interface Props {
    agreed: boolean;
    onAgreedChange: (value: boolean) => void;
}

function ChargeAgreements({ agreed, onAgreedChange }: Props) {
    const { t } = useTranslation('prepaidCard');
    const termCategories = useTermCategories('PREPAY');

    if (termCategories.length === 0) {
        return null;
    }

    return (
        <Container>
            <Accordion
                initialOpen={false}
                title={(
                    <Checkbox isChecked={agreed}
                        toggleCheckbox={() => onAgreedChange(!agreed)}>
                        <Text size='body-short' fontWeight='medium' color={colors.gray8}>
                            {t('charge.agreeTerms')}
                        </Text>
                    </Checkbox>
                )}>
                <Column fullWidth spacing={1}>
                    {termCategories.map((category) => (
                        <Link key={category.id}
                            activityName='TermDetailActivity'
                            activityParams={{ termCategoryId: category.id }}
                            css={css`text-decoration: none; width: 100%;`}>
                            <Row fullWidth justify='space-between' align='center' css={rowCss}>
                                <Text size='body-short' color={colors.textSecondary}>{category.title}</Text>
                                <Text size='body-long' fontWeight='bold' color={colors.gray6}
                                    css={css`text-decoration: underline;`}>
                                    {t('charge.viewDetail')}
                                </Text>
                            </Row>
                        </Link>
                    ))}
                </Column>
            </Accordion>
        </Container>
    );
}

const Container = styled.section`
    width: 100%;
`;

const rowCss = css`
    padding: 10px 0;
`;

export default ChargeAgreements;
